"use client ";

import React from "react";
import "./AboutBanner.scss";
import { ReactComponent as HeroScroll } from "../../assets/svg/hero-scroll-btn.svg";

const AboutBanner = () => {
  const scrollToSection = () => {
    const section = document.getElementById("aboutSection");
    const offsetTop = section.offsetTop;

    // Scroll to the top of the section with smooth animation
    window.scrollTo({
      top: offsetTop,
      behavior: "smooth",
    });
  };
  return (
    <section className="section aboutBanner">
      <article className="aboutBanner__container container">
        <HeroScroll className="scroll-btn" onClick={scrollToSection} />
      </article>
    </section>
  );
};

export default AboutBanner;
